class VortexAPI {
  constructor() {
    this.rootUrl = "/vrtx/__vrtx/static-resources";
    this.propertySearchService = "/vrtx/__vrtx/app-services/property-query";

    this.useCache = false;
  }

  debug(debugUrl) {
    this.adminUrl = debugUrl;
    this.useCache = true;
  }

  getProgram(cb) {
    var path = location.pathname;
    if(/\/$/.test(path)) {
      path += "index.html";
    }

    var query = "uri = " + path;
    var fields = "*";
    var sort = "publish-date desc";

    return this.getPropertySearchResults(query, fields, sort, (data) => {
      if(data.results && data.results.length > 0) {
        var resultsAdmission = data.results[0].properties;

        var title = resultsAdmission["fs:fs-studieretning-title"] ? resultsAdmission["fs:fs-studieretning-title"] : resultsAdmission["fs:fs-studieprogram-title"];

        var pathname = location.pathname;
        if(pathname.startsWith("/studier/program/ppu-master/opptak/")) {
          var titlePPUCtx = " med praktisk-pedagogisk utdanning";
          if(pathname.endsWith("engelsk.html")) { title = "Engelsk" + titlePPUCtx; }
          if(pathname.endsWith("engelskdidaktikk.html")) { title = "Engelskdidaktikk" + titlePPUCtx; }
          if(pathname.endsWith("fransk.html")) { title = "Fransk" + titlePPUCtx; }
          if(pathname.endsWith("historie.html")) { title = "Historie" + titlePPUCtx; }
          if(pathname.endsWith("matematikk.html")) { title = "Matematikk" + titlePPUCtx; }
          if(pathname.endsWith("matematikkdidaktikk.html")) { title = "Matematikkdidaktikk" + titlePPUCtx; }
          if(pathname.endsWith("naturfagenes-didaktikk.html")) { title = "Naturfagenes didaktikk" + titlePPUCtx; }
          if(pathname.endsWith("norsk.html")) { title = "Norsk" + titlePPUCtx; }
          if(pathname.endsWith("norskdidaktikk.html")) { title = "Norskdidaktikk" + titlePPUCtx; }
          if(pathname.endsWith("rel-livs-etikkdidaktikk.html")) { title = "Religion-, livssyns- og etikkdidaktikk" + titlePPUCtx; }
          if(pathname.endsWith("religion-livssyn-etikk.html")) { title = "Religion, livssyn og etikk" + titlePPUCtx; }
          if(pathname.endsWith("spansk.html")) { title = "Spansk" + titlePPUCtx; }
          if(pathname.endsWith("samfunnsfagdidaktikk.html")) { title = "Samfunnsfagsdidaktikk" + titlePPUCtx; }
          if(pathname.endsWith("tysk.html")) { title = "Tysk" + titlePPUCtx; }
        }

        cb({
          title: title,
          programCode: (resultsAdmission["fs:fs-studieretning-code"]
                        ? resultsAdmission["fs:fs-studieretning-code"]
                        : resultsAdmission["fs:fs-studieprogram-code"]),
          contentLocale: resultsAdmission["contentLocale"],

          dates: resultsAdmission["resource:studiet-master-frister"],
          datesText: resultsAdmission["resource:studiet-master-spesielle-fakta"],
          availablePlaces: resultsAdmission["resource:studiet-master-studieplasser"],
          experienceBased: resultsAdmission["resource:opptak-master-erfaringsbasert"],

          "studiet-master-pris-fri": resultsAdmission["resource:studiet-master-pris-fri"],
          "opptak-master-spesielle-krav-fri": resultsAdmission["resource:opptak-master-spesielle-krav-fri"],
          "opptak-master-sprakkrav-fri": resultsAdmission["resource:opptak-master-sprakkrav-fri"],
          "dok-master-fri": resultsAdmission["resource:dok-master-fri"],
          "studiet-master-rangering-fri": resultsAdmission["resource:studiet-master-rangering-fri"],
          "studiet-master-innpassing-utd-fri": resultsAdmission["resource:studiet-master-innpassing-utd-fri"],

          fellestekst: {
            "opptak-master-sprakkrav": resultsAdmission["resource:opptak-master-sprakkrav"],
            "opptak-master-eksportkontroll": resultsAdmission["resource:opptak-master-eksportkontroll"],
            "opptak-master-politiattest": resultsAdmission["resource:opptak-master-politiattest"],
            "studiet-master-rangering": resultsAdmission["resource:studiet-master-rangering"],
            "studiet-master-innpassing-utd": resultsAdmission["resource:studiet-master-innpassing-utd"]
          }
        });
      }
    });
  }

  getFellestekster(cb) {
    var query = "uri = " + App.pathFellestekst + "*";;
    var fields = "*";
    var sort = "publish-date desc";

    var cbLocal = (data) => {
      if(data.results && data.results.length > 0) {
        var sharedTexts = {};

        data.results.forEach((file) => {
          var name = file.name.replace(/\.html$/i, "");
          sharedTexts[name] = {};

          if(file.properties["resource:shared-text-box"]) {
            file.properties["resource:shared-text-box"].forEach((sharedText) => {
              sharedTexts[name][sharedText.id] = sharedText;
            });
          }
        });
        cb(sharedTexts);
      }
    };

    // ### ExceptionS for fritekst ###
    var api = this;
    var path = location.pathname;
    if(/\/$/.test(path)) {
      path += "index.html";
    }
    $.get(path, function(data) {
      var dataHtml = $($.parseHTML(data));
      var elm = dataHtml.find(".opptak-master-spesielle-krav-fri");
      if(elm.length) {
        App.program["opptak-master-spesielle-krav-fri"] = elm.html();
      }
      var elm = dataHtml.find(".studiet-master-pris-fri");
      if(elm.length) {
        App.program["studiet-master-pris-fri"] = elm.html();
      }
      var elm = dataHtml.find(".opptak-master-sprakkrav-fri");
      if(elm.length) {
        App.program["opptak-master-sprakkrav-fri"] = elm.html();
      }
      var elm = dataHtml.find(".dok-master-fri");
      if(elm.length) {
        App.program["dok-master-fri"] = elm.html();
      }
      var elm = dataHtml.find(".studiet-master-rangering-fri");
      if(elm.length) {
        App.program["studiet-master-rangering-fri"] = elm.html();
      }
      var elm = dataHtml.find(".studiet-master-innpassing-utd-fri");
      if(elm.length) {
        App.program["studiet-master-innpassing-utd-fri"] = elm.html();
      }
      var elm = dataHtml.find(".studiet-master-spesielle-fakta");
      if(elm.length) {
        App.program["studiet-master-spesielle-fakta"] = elm.html();
      }

      return api.getPropertySearchResults(query, fields, sort, cbLocal);
    });
  }

  /* ------ LOW-LEVEL ------ */

  getPropertySearchResults(query, fields, sort, cb) {
    return $.ajax({
      type: "GET",
      url: this.propertySearchService +
           "?q=" + encodeURIComponent(query) +
           "&fields=" + encodeURIComponent(fields) +
           "&sort=" + encodeURIComponent(sort) +
           "&format=json-compact",
      cache: this.useCache,
      contentType: "application/json;charset=utf-8",
      success: (data) => {
        cb(data);
      },
      error: (xhr, textStatus, errorThrown) => {
        this.error("getPropertySearchResults", xhr, textStatus, errorThrown);
      }
    });
  }

  error(fnName, xhr, textStatus, errorThrown) {
    UiO2.dialogOkCreateOpen($("#main"), xhr.status + " - " + xhr.statusText, "Invoked from: " + fnName);
  }
}
export default new VortexAPI;
